import bitUSD from "../assets/venture/bitUSD.png";
import SLALayer from "../assets/venture/SLALayer.png";
import smAtomica from "../assets/venture/smAtomica.png";
import stakingModules from "../assets/venture/stakingModules.png";
import creditArenas from "../assets/venture/creditArenas.png";

export const focusItems = [
  { id: "defi", text: "Defi Insurance" },
  { id: "staking", text: "Staking, Restaking & Governance Solutions" },
  {
    id: "collateralized",
    text: "Collateralized and Uncollateralized Credit Solutions",
  },
  { id: "multi", text: "Multi-collateral, multi-chain Stablecoin" },
  { id: "w3Infrastructure", text: "Web3 Infrastructure SLAs" },
];

export const ventureStartups = [
  {
    id: "bitUsd",
    title: "BitUSD / Bit Protocol",
    imgSrc: bitUSD,
    tagList: ["Protocol", "Stablecoin"],
    text: "#1 Native Multi-chain CDP Protocol behind $BitUSD the most decentralized, crypto-backed overcollateralized stablecoin.",
    link: "http://bitusd.finance",
  },
  {
    id: "creditArenas",
    title: "Creators Bank",
    imgSrc: creditArenas,
    tagList: [],
    text: "Creators Bank is an on-chain credit ecosystem enabling permissionless creation of isolated credit pools tailored for creators, communities, and DAOs. It focuses on unlocking peer-to-peer lending and decentralized underwriting - giving underbanked actors access to Web3-native financing tools.",
    link: "",
  },
  {
    id: "SLALayer",
    title: "SLALayer/ProteusShield",
    imgSrc: SLALayer,
    tagList: ["Protocol", "Stablecoin"],
    text: "SLA Layer is an Actively Validated Service (AVS) built to enforce Service-Level Agreements (SLAs) in decentralized infrastructure. By integrating with EigenLayer restaking, it offers performance guarantees (uptime, latency, correctness) for subgraphs, Filecoin storage, and other mission-critical services. Proteus Shield is its risk engine - managing slashing logic, conditions, and insurance triggers.",
    link: "https://www.slalayer.xyz/",
  },
  {
    id: "stakingModules",
    title: "Staking Modules",
    imgSrc: stakingModules,
    tagList: ["Protocol", "Stablecoin"],
    text: "Staking Modules is a modular infrastructure suite for integrating staking into any protocol or dApp. It supports native staking, liquid staking, and restaking mechanisms - designed to help protocols incentivize network participation and secure their ecosystems through flexible reward and validator logic.",
    link: "https://stakingmodule.protofire.io/",
  },
  {
    id: "atomica",
    title: "Safety Modules",
    imgSrc: smAtomica,
    tagList: ["Insurance solutions"],
    text: "Safety Modules are decentralized insurance vaults that protect DeFi protocols from smart contract risk, oracle failures, and governance attacks. These modules let protocols and users contribute capital to cover risks while earning premiums - offering a transparent, trustless layer of security.",
    link: "http://atomica.org/",
  },
];

export const advantages = [
  {
    title: "Funding & Investment",
    description: "Access strategic capital to accelerate your growth.",
  },
  {
    title: "Mentorship & Guidance",
    description:
      "Leverage the operational framework that experienced founders and blockchain experts have built.",
  },
  {
    title: "Go-To-Market Support",
    description:
      "Leverage our network and resources to refine your business model.",
  },
  {
    title: "Spin-Off & Growth Trajectory",
    description: "Transition from incubation to a fully independent entity.",
  },
  {
    title: "Backoffice support",
    description:
      "Focus on your product. Finance, legal, people operations, payroll, recruiting, and marketing functions are covered according to the highest industry standards.",
  },
  {
    title: "Pre-validated Talent Pool",
    description:
      "Grow fast by recruiting engineers with proven delivery experience.",
  },
];

export const participantItems = [
  "Develop and validate high-potential blockchain business models.",
  "Access expert support to refine your product and market fit.",
  "Engage with investors and partners to drive adoption and growth.",
  "Prepare for an independent spin-off and sustainable revenue generation.",
];

export const programStructure = [
  {
    title: "Application & Proposal Submission",
    description: "Present your vision and business case.",
  },
  {
    title: "Validation & Market Assessment",
    description: "Work with our experts to refine your concept.",
  },
  {
    title: "Prototype & MVP Development",
    description: "Build and test your solution.",
  },
  {
    title: "Go-To-Market Execution",
    description: "Develop a scalable growth strategy.",
  },
  {
    title: "Scaling & Spin-Off",
    description: "Transition into an independent venture.",
  },
];
